(() => {
if(customElements.get('ama-page-banner')) return;
customElements.define('ama-page-banner',class extends HTMLElement {
 connectedCallback(){
  const video=this.querySelector('video'), button=this.querySelector('button'); if(!video||!button||this.cleanup)return;
  const abort=new AbortController(), options={signal:abort.signal};
  let automatic=this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
  video.muted=true; video.defaultMuted=true; video.setAttribute('playsinline','');
  const sync=()=>{button.textContent=video.paused?'Play background video':'Pause background video';};
  const play=()=>{const p=video.play();if(p)p.catch(sync);};
  button.hidden=false;sync();
  video.addEventListener('play',sync,options);video.addEventListener('pause',sync,options);
  button.addEventListener('click',()=>{automatic=false;video.paused?play():video.pause();},options);
  const attempt=()=>{if(automatic&&this.getBoundingClientRect().bottom>0&&this.getBoundingClientRect().top<innerHeight)play();};
  ['touchstart','pointerdown','scroll'].forEach(event=>window.addEventListener(event,attempt,{passive:true,signal:abort.signal}));
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)video.pause();else attempt();}));observer.observe(this);
  this.cleanup=()=>{abort.abort();observer.disconnect();video.pause();};attempt();
 }
 disconnectedCallback(){if(this.cleanup){this.cleanup();this.cleanup=null;}}
});
})();
